import { useTranslation } from "react-i18next";
import Pack from "../Pack";
import ButtonBtn from "../buttons/ButtonBtn";
import styles from "../../css/reviews/Sections.module.css";
import base from "../../css/reviews/Reviews.module.css";

const ForWhomReviews = ({ onCtaClick }) => {
  const { t } = useTranslation();
  const content = t("reviews.forWhom", { returnObjects: true });

  return (
    <Pack dataComponent={"for-whom-reviews"}>
      <h2 className={`title ${base.heading}`}>{content.heading}</h2>
      <div className={styles.forWhom}>
        {Array.isArray(content.texts) &&
          content.texts.map((item, index) => (
            <div key={index} className={styles.forWhomItem}>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
      </div>
      {content.btn && (
        <div className={styles.center}>
          <ButtonBtn
            onClick={(e) => {
              e.target.blur?.();
              onCtaClick?.();
            }}
            style={{ marginTop: "35px", marginInline: "auto" }}
            hoverBg={"white"}
            hoverColor={"black"}
          >
            {content.btn}
          </ButtonBtn>
        </div>
      )}
    </Pack>
  );
};

export default ForWhomReviews;
